import { render, staticRenderFns } from "./cModalSale.vue?vue&type=template&id=4b8cdd6a&scoped=true"
import script from "./cModalSale.vue?vue&type=script&lang=js"
export * from "./cModalSale.vue?vue&type=script&lang=js"
import style0 from "./cModalSale.vue?vue&type=style&index=0&id=4b8cdd6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8cdd6a",
  null
  
)

export default component.exports